import { Loader2 } from 'lucide-react';

interface ModalFormFooterActionsProps {
  onCancel: () => void;
  submitting: boolean;
  /** Truthy => edit mode (shows editLabel); falsy => create mode (shows createLabel). */
  editing: unknown;
  /** Submit button label in create mode (editing falsy). */
  createLabel: string;
  /** Submit button label in edit mode (editing truthy). */
  editLabel?: string;
  cancelLabel?: string;
  /** When set, scopes the submit button to a form by id (HTML `form` attribute). */
  formId?: string;
}

export default function ModalFormFooterActions({
  onCancel,
  submitting,
  editing,
  createLabel,
  editLabel = 'Save Changes',
  cancelLabel = 'Cancel',
  formId,
}: ModalFormFooterActionsProps) {
  return (
    <>
      <button
        type="button"
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
      >
        {cancelLabel}
      </button>
      <button
        type="submit"
        form={formId}
        disabled={submitting}
        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white btn-brand rounded-lg disabled:opacity-60"
      >
        {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
        {editing ? editLabel : createLabel}
      </button>
    </>
  );
}
